import { createContext, useContext } from 'react'

export const ClientRouterContext = createContext(null)
export const useClientRouterContext = () => useContext(ClientRouterContext)